<template>
  <div id="orderReports" v-if="orderReport.selectAuth">
    密码：xora
     <iframe id="mainIframe" name="mainIframe" width="100%" height="1000px" src="https://me.bdp.cn/share/index.html?shareId=sdo_70062d3c866ab1c2f420241bee792e48" frameborder="0" scrolling="auto" ></iframe>
<!-- https://me.bdp.cn/api/su/FYE4S6BO -->
    <!-- <el-row type="flex"  justify="space-between">
      <el-col :span="6">
        <div >

                   <iframe id="mainIframe" name="mainIframe" width="1000%" src="https://me.bdp.cn/api/su/P9EH0UNL" frameborder="0" scrolling="auto" ></iframe>
          <chart :options="orderReportAll"/>
        </div>
      </el-col>
      <el-col :span="6">
        <div >

        </div>
      </el-col>
      <el-col :span="6">
        <div>

        </div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
  import {getPermission} from "../../api/authRequest";
  import ECharts from "vue-echarts";
  import "echarts/lib/component/tooltip";
  import"echarts/lib/chart/bar";
  import "echarts/lib/component/title";
  import "echarts/lib/chart/line"
  export default {
    components: {
      'chart': ECharts
    },
    data() {
      return{
        orderReport: {
          selectAuth: false
        },
        orderReportAll: {
        }
      }
    },
    created() {

    },
    mounted() {
      this.orderReport.selectAuth = getPermission("/system/finReport/getReport");
      this.getAll();
    },
    methods: {
      getAll(){
        this.orderReportAll={
          backgroundColor: "#344b58",
          title:{
            text:"订单汇总",
             textStyle: {
              color: '#fff',
              fontSize: '22'
            },
          },
          "xAxis": [{
            "type": "category",
            "axisLine": {
              lineStyle: {
                color: '#90979c'
              }
            },
            "splitLine": {
              "show": false
            },
            "axisTick": {
              "show": false
            },
            "splitArea": {
              "show": false
            },
            "axisLabel": {
              "interval": 0,

            },
            "data": [1,2,3,4,5,6,7,8,9,10,11,12],
          }],
          "yAxis": [{
            "type": "value",
            "splitLine": {
              "show": false
            },
            "axisLine": {
              lineStyle: {
                color: '#90979c'
              }
            },
            "axisTick": {
              "show": false
            },
            "axisLabel": {
              "interval": 0,

            },
            "splitArea": {
              "show": false
            },

          }],
          series: [{
            "data": [709,1917,2455,2610,1719,1433,1544,3285,5208,3372,2484,4078],
            type: 'bar',
            "itemStyle": {
              "normal": {
                "color": "rgba(255,144,128,1)",
                "label": {
                  "show": true,
                  "textStyle": {
                    "color": "#fff"
                  },
                  "position": "insideTop",
                  formatter: function(p) {
                    return p.value > 0 ? (p.value) : '';
                  }
                }
              }
            },
          }]
        }
      }
    },
  }
</script>
<style type="text/css" lang="scss" scoped>
  
</style>



// WEBPACK FOOTER //
// bdpReport.vue?2ec4adbc